import styled from 'styled-components';
import { SearchInput } from '../../../../CommonComponents/commonStyles';

export const Mainwrapper = styled.div`
    margin: 30px 0;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);
        border: solid 1px ${props => props.theme.border.pill};
        background-color: ${props => props.theme.backgroundColor.layoutLight};
        padding: 12px;
        position: absolute;
        z-index: 4;
        top: 40px;
        width: 100%;
    }
    @media only screen and (max-width: 991.91px) and (min-width: 768px) {
        display: flex;
        align-items: center;
      }
`
export const Trangle = styled.span`
    width: 12px;
    height: 12px;
    background-color: ${props => props.theme.backgroundColor.layoutLight};
    position: absolute;
    z-index: 6;
    top: -6px;
    right: 40px;
    transform: rotate(45deg);
    border-top: 1px solid ${props => props.theme.border.pill};
    border-left: 1px solid ${props => props.theme.border.pill};
    display:none;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        display: block;
    }
`
export const SearchInputTxn = styled(SearchInput)`
    margin-right: 30px;
    &.ant-input-affix-wrapper {
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            margin-bottom: 10px;
        }
    }
    
`

export const RadioContent = styled.span`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.5;
    color: ${props => props.theme.fontColors.textColor};
    padding: 0 40px 0 2px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
        padding: 0px;
        padding-left: 2px;
    }
`

export const RadioWrap = styled.span`
    .ant-radio-group {
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            display: flex;
        }
        @media only screen and (max-width: 991.91px) and (min-width: 768px) {
            display: flex;
          }
    }
        &:hover {
            border-color: ${props => props.theme.border.teal};
        }
    }
    .ant-radio-checked .ant-radio-inner {
        border-color: ${props => props.theme.border.teal};
    }
    .ant-radio-wrapper{
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            margin-top:20px;
        }
    }
`

export const DisplayFlex = styled.div`
    display: flex;
    justify-content: space-between;
`
export const TableContainer = styled.div`   
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding: 0px 20px 20px;
    }
`
export const FilterBtnContainer = styled.div`
    display: flex;
    // align-items: center;
    justify-content: flex-end;
`
export const FilterBtn = styled.div`   
    width: 81px;
    height: 40px;
    border: solid 1px ${props => props.theme.border.pill};
    background-color: ${props => props.theme.backgroundColor.layoutLight};
    align-items: center;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.secondary};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: ${props => props.theme.fontColors.textColor};
    margin: 20px;
    display: none;
    justify-content: space-around;
    padding: 0 7px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        display: flex;
    }
`